/* global console */
/* eslint-disable no-console */

// TODO: Use "warning" npm module like React is switching to.
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var warn = function warn(message) {
  if (process.env.NODE_ENV !== "production") {
    if (console && console.warn) {
      console.warn(message);
    }
  }
};
exports.warn = warn;


/*****************
 ** WEBPACK FOOTER
 ** ./~/victory-util/lib/log.js
 ** module id = 136
 ** module chunks = 0
 **/